import React from 'react';
import { FormRouter } from './form-router';
import { Container } from './styles';

export const Content = () => (
  <Container>
    <FormRouter />
  </Container>
);
